import { message, Modal } from "antd";
import { boardServices } from "../api";
import axios from "axios";

const hardcodeToken = "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiJiZWEwODRmMS1iOWI0LTQ2ZGEtYjZiZi1kNDg1YjE2YWJjZGQiLCJuYW1lIjoiQXJlZWogWmFoaWQgQWxpIiwiaW1hZ2UiOiJodHRwczovL3dvcmt3LmNvbS9SZXNvdXJjZXNcXDBhYjVmOWMwLWY5NDgtNGM0MC04ZGFkLWM1OGJhOTlmYjc2NVxcSW1hZ2VzXFxiZGM2YmM1NC0wNjAwLTQxOGYtYTM0OS1mMDIyMWRhYjU2MGYuanBlZyIsImVtYWlsIjoiYXJlZWpAbWlsZXRhcC5jb20iLCJidXNpbmVzc0lkIjoiMGFiNWY5YzAtZjk0OC00YzQwLThkYWQtYzU4YmE5OWZiNzY1IiwidmVyIjoiNzJBNEQ2OUQtNDgzMS00NzhGLUFFMDQtRUQ0ODI1MDlGRTkxIiwiaWgiOiJJR2ZqWnExWmFjNDN3MmhlSXFSd2Y4OHFRZzFHbWVSSWljalIreHMzSVowPSIsImlzIjoiRUJhZzJMbTlBaW1CTnQ0bkxrMU5IZz09IiwicGgiOiIzUUhNbFp5QTFvQm5YekFKbVg5OTRnZnFGaTl5WlhndFdtL1cwNHVwVXlrPSIsInBzIjoiaGF4UW5Pcm5YN2ovV0pmNjNXS2NiUT09IiwianRpIjoiMDA5OTZhMjMtZDllYy00NGFjLTk3N2UtNDk5NGNkNzY0NGEwIiwibmJmIjoxNzYyNDAzNzA5LCJleHAiOjE3NjI1NzY1MDl9.AmvXo11njn2qX0alzJKYAAPzObKvykmWrNsHWzENyaZFKZww2Ed9UvksCNqhO0g-Oji-EGT0tugrqIVWHcSzzeqNQcKMeWTACVbLCHQOCc2nHx6jKAH8HKU1hCt7-foClYKAY3MfRYzA_KHqsLZ1LJ7zt_V4yu039Z-6rGrI01RwqVOT49dKl-BRGaNeENheoicMiViN1l-Jn9OqPS1ci-hpI2oi2j7mJjbCFmZbrZwb1vKHkrUtHSv2WGeX5C5gF4UxRa1-1DWrchUD8ojEIZhvNA_ZY9AsJS9-_MPESg2FiH5COdiJx_UDtbV0osskZb5ALvaotBmFOsvoVIX2wQ";
const { confirm } = Modal;

function getCookieValue(name) {
  const regex = new RegExp(`(^| )${name}=([^;]+)`)
  const match = document.cookie.match(regex)
  if (match) {
    return match[2]
  }
}

export function getWorkWiseAuthToken() {
  const searchParams = new URLSearchParams(document.location.search);
  let cookieToken = getCookieValue("token")
  let queryToken = searchParams.get("token");
  const finalToken = queryToken || cookieToken || hardcodeToken;
  return finalToken;
}
export const formatFileSize = (bytes) => {
  if (bytes === 0) return "0 Bytes";

  const units = ["Bytes", "KB", "MB", "GB"];
  let size = bytes;
  let unitIndex = 0;

  while (size >= 1024 && unitIndex < units.length - 1) {
    size /= 1024;
    unitIndex++;
  }

  if (unitIndex === 0) {
    return `${size} ${units[unitIndex]}`;
  } else if (unitIndex === 1 && size < 50) {
    return `${parseFloat(size.toFixed(0))} ${units[unitIndex]}`;
  } else {
    return `${parseFloat(size.toFixed(2))} ${units[unitIndex]}`;
  }
};


export const getWatermarkData = async () => {
  const now = new Date();
  const currentDateTime = now.toLocaleString();

  // Get IP address
  let ip = 'N/A';
  try {
    const response = await fetch('https://api.ipify.org?format=json');
    const data = await response.json();
    ip = data.ip;
  } catch (error) {
    console.error("Error fetching IP:", error);
    message.error("Could not fetch IP address");
  }

  // Get location
  let location = { lat: 'N/A', lng: 'N/A' };
  try {
    location = await new Promise((resolve, reject) => {
      if (!navigator.geolocation) {
        message.error("Geolocation not supported");
        return resolve(location);
      }

      navigator.geolocation.getCurrentPosition(
        (position) => resolve({
          lat: position.coords.latitude,
          lng: position.coords.longitude
        }),
        (error) => {
          handleGeolocationError(error);
          resolve(location); // Return default on error
        }
      );
    });
  } catch (error) {
    console.error("Location error:", error);
  }

  return {
    currentDateTime,
    ip,
    location
  };
};

const handleGeolocationError = (error) => {
  switch (error.code) {
    case error.PERMISSION_DENIED:
      message.error("Location access denied. Please enable permissions.");
      break;
    case error.POSITION_UNAVAILABLE:
      message.error("Location information unavailable.");
      break;
    case error.TIMEOUT:
      message.error("Location request timed out.");
      break;
    default:
      message.error("Unknown location error occurred.");
  }
};
export const getMaxRightOfElement = (canvas) => {
  let maxRight = 0;

  canvas.getObjects().forEach((obj) => {
    // Calculate right edge considering scale
    const rightEdge = obj.left + (obj.width || 0) * (obj.scaleX || 1);

    if (rightEdge > maxRight) {
      maxRight = rightEdge;
    }
  });

  return maxRight;
};
export const centerObjectInViewport = (canvas, obj) => {
  const zoom = canvas.getZoom();
  const canvasWidth = canvas.getWidth();
  const canvasHeight = canvas.getHeight();

  const centerX = obj.left + (obj.width * (obj.scaleX || 1)) / 2;
  const centerY = obj.top + (obj.height * (obj.scaleY || 1)) / 2;

  const vpt = canvas.viewportTransform.slice();
  vpt[4] = canvasWidth / 2 - centerX * zoom;
  vpt[5] = canvasHeight / 2 - centerY * zoom;

  canvas.setViewportTransform(vpt);
  canvas.renderAll();
};

export const centerAllObjectsInViewport = (canvas) => {
  const objects = canvas.getObjects();
  if (objects.length === 0) return;

  const zoom = canvas.getZoom();
  const canvasWidth = canvas.getWidth();
  const canvasHeight = canvas.getHeight();

  // Calculate the bounding box for all objects
  let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;

  objects.forEach(obj => {
    const scaleX = obj.scaleX || 1;
    const scaleY = obj.scaleY || 1;
    const width = obj.width * scaleX;
    const height = obj.height * scaleY;

    const left = obj.left;
    const top = obj.top;

    minX = Math.min(minX, left);
    minY = Math.min(minY, top);
    maxX = Math.max(maxX, left + width);
    maxY = Math.max(maxY, top + height);
  });

  const groupWidth = maxX - minX;
  const groupHeight = maxY - minY;

  const centerX = minX + groupWidth / 2;
  const centerY = minY + groupHeight / 2;

  const vpt = canvas.viewportTransform.slice();
  vpt[4] = canvasWidth / 2 - centerX * zoom;
  vpt[5] = canvasHeight / 2 - centerY * zoom;

  canvas.setViewportTransform(vpt);
  canvas.renderAll();
};

export const saveToLocalStorage = (docId, data) => {
  try {
    const localData = {
      data: data,
      lastUpdateTime: new Date().toISOString()
    };
    // Retrieve existing data from localStorage or initialize with an empty object
    const existingData = JSON.parse(localStorage.getItem('offlineIdeationData')) || {};
    // Replace or add the sheet data for the given docId
    existingData[docId] = localData;
    // Save updated data back to localStorage
    localStorage.setItem('offlineIdeationData', JSON.stringify(existingData));
  } catch (error) {
    console.error('Error saving to localStorage:', error);
  }
};

export const removeOfflineData = (id) => {
  const offlineData = JSON.parse(localStorage.getItem('offlineIdeationData') || '{}');
  delete offlineData[id];
  localStorage.setItem('offlineIdeationData', JSON.stringify(offlineData));
};

export const isOffline = () => {
  return !navigator.onLine;
};
